import BaseService from '@/service/modules/BaseService'
import BasePageableInfo from '@/model/modules/BasePageableInfo'
import axios from '@/axios'
import StealFreightInfo from '@/model/modules/StealFreightInfo'

export default class StealFreightServiceService extends BaseService {
  protected static baseUrl: string = '/weight-difference'

  public static list(example: { [index: string]: any }, pageNum: number, pageSize: number): Promise<BasePageableInfo<StealFreightInfo>> {
    example.page = pageNum
    example.size = pageSize
    return new Promise<BasePageableInfo<StealFreightInfo>>((resolve, reject) => {
      axios.get(this.baseUrl + '/list', {
        params: example
      }).then(resp => {
        const result: BasePageableInfo<StealFreightInfo> = new BasePageableInfo()
        result.count = resp.data.body.totalElements
        result.dataList = resp.data.body.content
        resolve(result)
      })
    })
  }
}
